import React from "react";
import Title from "../../../components/Title/Title";

const ProgramCommittee2027page = () => {
    return (
        <div>
            <Title>Program Committee</Title>

            [COMING SOON]
        </div>
    )
}

export default ProgramCommittee2027page
